<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="my-3 flex flex-col md:flex-row gap-4 items-center">
  <div class="flex items-center gap-3 my-3">
    <app-back-option-section [loading]="loading"></app-back-option-section>
    <h2>Vehicle Details - {{ fleetData?.vehicleDetails?.registrationNumber }}</h2>
  </div>
  <nz-space *ngIf="loading" nzSize="middle">
    <nz-skeleton-element *nzSpaceItem nzType="button" [nzShape]="'round'"
                         [nzActive]="true"></nz-skeleton-element>
  </nz-space>
  <div *ngIf="!loading" class="flex">
    <div *ngIf="!hasPermission('FLEET_UPDATE')">
      <nz-tag *ngIf="fleetData?.active"
              [nzColor]="'#3ab200'" class="rounded-full"
      >Active
      </nz-tag>
      <nz-tag *ngIf="!fleetData?.active"
              [nzColor]="'#F3454C'" class="rounded-full"
      >Inactive
      </nz-tag>
    </div>
    <div *appHasAnyPrivilege="'FLEET_UPDATE'">
      <nz-tag nz-popconfirm nzPopconfirmTitle="Are you sure you want to change the Active status to Inactive?"
              (nzOnConfirm)="showAddFleetNoteModal()" (nzOnCancel)="cancel()"
              *ngIf="fleetData?.active"
              [nzColor]="'#3ab200'" class="rounded-full hover:cursor-pointer"
      >Active
      </nz-tag>
      <nz-tag nz-popconfirm nzPopconfirmTitle="Are you sure you want to change the Inactive status to Active?"
              (nzOnConfirm)="showAddFleetNoteModal()" (nzOnCancel)="cancel()"
              *ngIf="!fleetData?.active"
              [nzColor]="'#F3454C'" class="rounded-full hover:cursor-pointer"
      >Inactive
      </nz-tag>
    </div>
    <div>
      <nz-tag *ngIf="fleetData?.availabilityStatus === availabilityStatus.AVAILABLE" [nzColor]="'#3ab200'"
              class="rounded-full"
      >Available
      </nz-tag
      >
      <nz-tag *ngIf="fleetData?.availabilityStatus === availabilityStatus.ON_TRANSFER" [nzColor]="'#FF8C00'"
              class="rounded-full"
      >On Transfer
      </nz-tag
      >
      <nz-tag *ngIf="fleetData?.availabilityStatus === availabilityStatus.ON_RENT" [nzColor]="'#2A7CF5'"
              class="rounded-full"
      >On Rent
      </nz-tag
      >
      <nz-tag *ngIf="fleetData?.availabilityStatus === availabilityStatus.OUT_OF_SERVICE" [nzColor]="'#F3454C'"
              class="rounded-full"
      >Out of Service
      </nz-tag
      >
    </div>
  </div>
</div>
<nz-tabset [(nzSelectedIndex)]="activeTabIndex">
  <nz-tab nzTitle="Vehicle Information" (nzClick)="updateBreadcrumbs('General-Info')">

    <div [ngClass]="!loading ? 'block' : 'hidden'">
      <nz-card>
        <div class="flex flex-col  lg:flex-row justify-between items-center">
          <h5>General Information</h5>
          <div class="flex flex-col  lg:flex-row mt-4 gap-2">
            <button [disabled]="!fleetData?.active" (click)="goto()" class="outline-button"
                    *appHasAnyPrivilege="'FLEET_UPDATE'" nz-button nzType="default">Edit Details
            </button>
            <button
              *ngIf="havePermissionWithOtherValues('REPORT_GENERATE', this.fleetData?.generalInformation?.vehicleType, 'RENT' )"
              nz-button nzType="primary" (click)="showReportGenerate();generatePdf()">Generate Car Rental Agreement
            </button>
            <span *appHasAnyPrivilege="'REPORT_GENERATE'">
            <button *ngIf="this.fleetData?.generalInformation?.vehicleType === 'RENT' && inventoryData.length > 0" nz-button nzType="primary" (click)="showReportGenerate();generateInventoryPdf()">Generate Initial Inventory Report</button>
          </span>
          </div>

        </div>
        <div class="my-3">

          <div *ngIf="!fleetData?.generalInformation?.vehicleImg?.length" class="w-[150px] h-[150px]">
            <img width="150px" height="150px" style="object-fit: cover" [src]="imgUploadPlaceholder" alt="">
          </div>
<!--          <div [ngClass]="(fleetData?.generalInformation?.vehicleImg?.length > 3) ? 'justify-start' : 'justify-center' "-->
          <div class="flex justify-start gap-3 my-2 image-swipper"
               *ngIf="fleetData?.generalInformation?.vehicleImg?.length">
            <div class="w-[300px] h-[300px]" *ngFor="let img of fleetData?.generalInformation?.vehicleImg">
              <img width="300px" height="300px" style="object-fit: cover; cursor: pointer" (click)="showModalImg(img)" [src]="img" alt="">
            </div>
          </div>
        </div>
        <div class="mt-5 grid xl:grid-cols-2 2xl:grid-cols-2 gap-8">
          <div class="sub-section">
            <div class="item-row">
              <p class="subject-name">Vehicle Type </p>
              <p class="subject-data">{{ fleetData?.generalInformation?.vehicleType ? (fleetData?.generalInformation?.vehicleType) : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Vehicle Category </p>
              <p class="subject-data">{{ vehicleCat?.name ? vehicleCat?.name : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Vehicle Sub Category </p>
            </div>
            <div class="item-row vehicle-sub-cat">
              <p class="subject-name">Rent A Car Code</p>
              <p class="subject-data flex flex-wrap"><span class="mr-2" *ngFor="let rentCode of fleetData?.generalInformation?.rentCarCode">{{ rentCode }}</span></p>
            </div>
            <div class="item-row vehicle-sub-cat">
              <p class="subject-name">Transfer Code</p>
              <p class="subject-data flex flex-wrap"><span class="mr-2" *ngFor="let transCode of fleetData?.generalInformation?.transferCode">{{ transCode }}</span></p>
            </div>
          </div>
        </div>

      </nz-card>

      <nz-card *ngIf="fleetData?.ownershipDetails" class="mt-5">
        <h5>Ownership Details</h5>
        <div class="mt-5 grid md:grid-clos-2  2xl:grid-cols-3 gap-8">
          <div class="sub-section">
            <div class="item-row">
              <p class="subject-name">Owner Name</p>
              <p class="subject-data">{{ fleetData?.ownershipDetails?.ownerName ? fleetData?.ownershipDetails?.ownerName : '-'}}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Contact Person</p>
              <p class="subject-data">{{ fleetData?.ownershipDetails?.contactPerson ? fleetData?.ownershipDetails?.contactPerson : '-'}}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Contact Email</p>
              <p class="subject-data">{{ fleetData?.ownershipDetails?.contactEmail ? fleetData?.ownershipDetails?.contactEmail : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Contact {{fleetData?.ownershipDetails?.contactNumber.length > 1 ? 'Numbers' : 'Number'}}</p>
              <p *ngFor="let coNo of fleetData?.ownershipDetails?.contactNumber" class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no"
                href="tel:{ coNo }}">{{ coNo }}</a></p>
            </div>
            <div class="item-row">
              <p class="subject-name">
                NIC No/ Passport No/ BR No
              </p>
              <p class="subject-data">{{ fleetData?.ownershipDetails?.registrationNumber ? fleetData?.ownershipDetails?.registrationNumber : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Issued Date</p>
              <p class="subject-data">{{ fleetData?.ownershipDetails?.issuedDate ? (fleetData?.ownershipDetails?.issuedDate | date: 'dd-MM-y') : '-' }}</p>
            </div>
          </div>
          <div class="sub-section">
            <div class="item-row">
              <p class="subject-name">Permanent Address</p>
              <p class="subject-data">
                {{ fleetData?.ownershipDetails?.permanentAddress ? fleetData?.ownershipDetails?.permanentAddress : '-' }}
              </p>
            </div>
            <div class="item-row">
              <p class="subject-name">Current Address</p>
              <p class="subject-data">
                {{ fleetData?.ownershipDetails?.currentAddress ? fleetData?.ownershipDetails?.currentAddress : '-'}}
              </p>
            </div>
          </div>
          <div class="sub-section">
            <p class="subject-name">Attachments</p>
            <div class="flex flex-row gap-2 items-center py-2">
              <div class="flex flex-col mt-2">
                <a *ngFor="let file of fleetData?.ownershipDetails?.vehicleBook" href="{{file.url}}"
                   [nz-tooltip]="file.name"
                   target="_blank"><span nz-icon nzType="file" class="text-sm" nzTheme="outline"></span><span
                  class="ml-2 text-sm"> - {{ file.name }}</span></a>
              </div>
            </div>
          </div>
        </div>
      </nz-card>

      <nz-card class="mt-5">
        <h5>Vehicle Details</h5>
        <div class="mt-5 grid  xl:grid-cols-3 gap-8">
          <div class="sub-section">
            <div class="item-row">
              <p class="subject-name">Vehicle Brand</p>
              <p class="subject-data">{{ fleetData?.vehicleDetails?.vehicleBrand ? fleetData?.vehicleDetails?.vehicleBrand : '-'}}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Model</p>
              <p class="subject-data">{{ fleetData?.vehicleDetails?.vehicleModel ? fleetData?.vehicleDetails?.vehicleModel : '-'}}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Fuel Type</p>
              <p class="subject-data">{{ fleetData?.vehicleDetails?.fuelType ? fleetData?.vehicleDetails?.fuelType :'-'}}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Transmission</p>
              <p class="subject-data">{{ fleetData?.vehicleDetails?.transmission ? fleetData?.vehicleDetails?.transmission : '-'}}</p>
            </div>
          </div>
          <div class="sub-section">
            <div class="item-row">
              <p class="subject-name">Engine Number</p>
              <p class="subject-data">{{ fleetData?.vehicleDetails?.engineNumber ? fleetData?.vehicleDetails?.engineNumber : '-'}}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Chassis Number</p>
              <p class="subject-data">{{ fleetData?.vehicleDetails?.chassisNumber ? fleetData?.vehicleDetails?.chassisNumber : '-'}}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Year of Manufacture</p>
              <p class="subject-data">{{ fleetData?.vehicleDetails?.manufactureDate ? (fleetData?.vehicleDetails?.manufactureDate | date: 'yyyy') : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Year of Register</p>
              <p class="subject-data">{{ fleetData?.vehicleDetails?.registerDate ? (fleetData?.vehicleDetails?.registerDate | date: 'yyyy') : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Registration Number</p>
              <p class="subject-data">{{ fleetData?.vehicleDetails?.registrationNumber ? fleetData?.vehicleDetails?.registrationNumber : '-'}}</p>
            </div>
          </div>
          <div class="sub-section">
            <div class="item-row">
              <p class="subject-name">Number of Seats</p>
              <p class="subject-data">{{ fleetData?.vehicleDetails?.seatsNumber ? fleetData?.vehicleDetails?.seatsNumber : '-'}}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Color</p>
              <p class="subject-data">{{ fleetData?.vehicleDetails?.color ? fleetData?.vehicleDetails?.color : '-'}}</p>
            </div>
<!--            <div class="item-row">-->
<!--              <p class="subject-name">License Plate</p>-->
<!--              <p class="subject-data">{{ fleetData?.vehicleDetails ? fleetData?.vehicleDetails?.LicensePlate : '-'}}</p>-->
<!--            </div>-->
          </div>
        </div>
      </nz-card>

      <nz-card *ngIf="fleetData?.generalInformation?.vehicleType === 'RENT'" class="mt-5">
        <h5>Agreement Details</h5>
        <div class="mt-5 grid  xl:grid-cols-3 gap-8">
          <div class="sub-section">
            <div class="item-row">
              <p class="subject-name">Monthly Rental Amount</p>
              <p class="subject-data">{{ fleetData?.agreementDetails?.MonthRentalAmount ? 'Rs. '+ fleetData?.agreementDetails?.MonthRentalAmount : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Renting Period</p>
              <p *ngIf="fleetData?.agreementDetails?.rentingPeriod !== 'OTHER'" class="subject-data">{{ agreementRentingPeriodCheck(fleetData?.agreementDetails?.rentingPeriod) }}</p>
              <p *ngIf="fleetData?.agreementDetails?.rentingPeriod === 'OTHER'" class="subject-data">{{ fleetData?.agreementDetails?.rentingPeriodOther }} Months</p>
            </div>
          </div>
          <div class="sub-section">
            <div class="item-row">
              <p class="subject-name">Entitled KM's</p>
              <p *ngIf="fleetData?.agreementDetails?.entitledKMS !== 'OTHER' && fleetData?.agreementDetails?.entitledKMS !== 'UNLIMITED'" class="subject-data">{{ agreementEntitledKmsCheck(fleetData?.agreementDetails?.entitledKMS) | unit }}</p>
              <p *ngIf="fleetData?.agreementDetails?.entitledKMS === 'UNLIMITED'" class="subject-data">{{ agreementEntitledKmsCheck(fleetData?.agreementDetails?.entitledKMS) }}</p>
              <p *ngIf="fleetData?.agreementDetails?.entitledKMS === 'OTHER'" class="subject-data">{{ fleetData?.agreementDetails?.entitledKMOther | unit }}</p>
            </div>
            <div *ngIf="fleetData?.agreementDetails?.entitledKMS !== 'UNLIMITED'" class="item-row">
              <p class="subject-name">Amount per exceeded mile</p>
              <p class="subject-data">{{ fleetData?.agreementDetails?.amount ? 'Rs. '+ fleetData?.agreementDetails?.amount : '-' }}</p>
            </div>
          </div>
        </div>
      </nz-card>

      <nz-card class="mt-5">
        <h5>Inventory Record</h5>
        <div class="mt-5 grid xl:grid-cols-3 gap-8">
          <div class="sub-section">
            <div class="item-row">
              <p class="subject-name">Current Date</p>
              <p class="subject-data">{{ date ? (date | date: 'dd-MM-y') : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Original Odometer</p>
              <p class="subject-data">{{ fleetData?.vehicleInventory?.odometer ? (fleetData?.vehicleInventory?.odometer | unit) :'-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Fuel Level</p>
              <p class="subject-data">{{ fleetData?.vehicleInventory?.fuelLevel ? (fleetData?.vehicleInventory?.fuelLevel | unit : "%") :'-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name subject-bold">Current Mileage</p>
              <p class="subject-data subject-bold">{{ fleetData?.currentMileage ? (fleetData?.currentMileage | unit) : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name subject-bold">Current Fuel Level</p>
              <p class="subject-data subject-bold">{{ fleetData?.currentFuelLevel ? (fleetData?.currentFuelLevel | unit: "%") : '-' }}</p>
            </div>
          </div>
          <div class="sub-section">
            <div class="item-row">
              <p class="subject-name">Last Service Date</p>
              <p class="subject-data">{{ fleetData?.vehicleInventory?.latestServiceDate ? (fleetData?.vehicleInventory?.latestServiceDate | date: 'dd-MM-y'): '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Last Service Mileage</p>
              <p class="subject-data">{{ fleetData?.vehicleInventory?.latestServiceMileage ? (fleetData?.vehicleInventory?.latestServiceMileage | unit) : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Service Duration</p>
              <p class="subject-data">{{ fleetData?.vehicleInventory?.serviceDuration ? (fleetData?.vehicleInventory?.serviceDuration | unit) : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Service will be done by</p>
              <p
                class="subject-data">{{ labelValOnServiceType(fleetData?.vehicleInventory?.serviceResponsible) }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Service oil change will be done by?</p>
              <p
                class="subject-data">{{ labelValOnServiceType(fleetData?.vehicleInventory?.serviceOilChangeResponsible) }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name subject-bold">Next Service Mileage</p>
              <p
                class="subject-data subject-bold">{{ fleetData?.vehicleInventory?.latestServiceMileage + fleetData?.vehicleInventory?.serviceDuration | unit }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name subject-bold">Next Service Due In</p>
              <p
                class="subject-data subject-bold">{{
                (fleetData?.vehicleInventory?.latestServiceMileage + fleetData?.vehicleInventory?.serviceDuration) -
                fleetData?.currentMileage | unit
                }}</p>
            </div>
          </div>
          <div class="sub-section">
            <div class="item-row">
              <p class="subject-name">Last Oil Change(T) Date</p>
              <p class="subject-data">{{ fleetData?.vehicleInventory?.latestOilChangeDate ? (fleetData?.vehicleInventory?.latestOilChangeDate | date: 'dd-MM-y') : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Last Oil Change(T) Mileage</p>
              <p class="subject-data">{{ fleetData?.vehicleInventory?.latestOilChangedMileage ? (fleetData?.vehicleInventory?.latestOilChangedMileage | unit) :'-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Oil Change(T) Duration</p>
              <p class="subject-data">{{ fleetData?.vehicleInventory?.oilChangeDuration ? (fleetData?.vehicleInventory?.oilChangeDuration | unit) : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Oil Change will be done by</p>
              <p
                class="subject-data">{{ labelValOnServiceType(fleetData?.vehicleInventory?.oilChangeResponsible) }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name subject-bold">Next Oil Change Mileage</p>
              <p
                class="subject-data subject-bold">{{
                fleetData?.vehicleInventory?.latestOilChangedMileage +
                fleetData?.vehicleInventory?.oilChangeDuration | unit
                }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name subject-bold">Next T-Oil Due In</p>
              <p
                class="subject-data subject-bold">{{
                (fleetData?.vehicleInventory?.latestOilChangedMileage +
                  fleetData?.vehicleInventory?.oilChangeDuration) - fleetData?.currentMileage | unit
                }}</p>
            </div>
          </div>
        </div>
      </nz-card>

      <nz-card class="mt-5">
        <h5>Other Details</h5>
        <div class="mt-5 grid xl:grid-cols-3 gap-8">
          <div class="sub-section">
            <div class="item-row">
              <p class="subject-name">Name of Insurance Company</p>
              <p class="subject-data">{{ fleetData?.otherDetails?.insuranceName ? fleetData?.otherDetails?.insuranceName : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Insurance Type</p>
              <p class="subject-data">{{ fleetData?.otherDetails?.insuranceType ? (fleetData?.otherDetails?.insuranceType | titlecase) : '-' }} Insurance</p>
            </div>
            <div *ngIf="fleetData?.otherDetails?.isLeasedVehicle" class="item-row">
              <p class="subject-name">Name of Bank / Lease Company</p>
              <p class="subject-data">{{ fleetData?.otherDetails?.leaseComName ? fleetData?.otherDetails?.leaseComName : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Insurance Expiry Date</p>
              <p class="subject-data">{{ fleetData?.otherDetails?.insuranceExpDate ? (fleetData?.otherDetails?.insuranceExpDate | date: 'dd-MM-y') : '-' }}</p>
            </div>
          </div>
          <div class="sub-section">
            <div class="item-row">
              <p class="subject-name">Revenue License Expiry Date</p>
              <p class="subject-data">{{ fleetData?.otherDetails?.revenueLicenceExpDate ? (fleetData?.otherDetails?.revenueLicenceExpDate | date: 'dd-MM-y') :'-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Eco Test Expiry Date</p>
              <p class="subject-data">{{ fleetData?.otherDetails?.ecoTestExpDate ? (fleetData?.otherDetails?.ecoTestExpDate  | date: 'dd-MM-y') :'-' }}</p>
            </div>
          </div>
          <div class="sub-section">
            <p class="subject-name">Attachments</p>
            <div class="flex flex-col mt-2">
              <a *ngFor="let file of fleetData?.otherDetails?.otherInfoFiles" href="{{file.url}}"
                 [nz-tooltip]="file.name"
                 target="_blank"><span nz-icon nzType="file" class="text-sm"
                                       nzTheme="outline"></span><span
                class="ml-2 text-sm"> - {{ file.name }}</span></a>
            </div>
          </div>
        </div>
      </nz-card>

      <nz-card *ngIf="fleetData?.generalInformation?.vehicleType === 'RENT'" class="mt-5">
        <h5>Payment Details</h5>
        <div class="mt-5 grid xl:grid-cols-3 gap-8">
          <div class="sub-section">
            <div class="item-row">
              <p class="subject-name">Payment Method</p>
              <p class="subject-data">{{ fleetData?.paymentDetails?.paymentMethod ? (fleetData?.paymentDetails?.paymentMethod | titlecase) : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Bank Name</p>
              <p class="subject-data">{{ fleetData?.paymentDetails?.bankName ? fleetData?.paymentDetails?.bankName : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Branch Name</p>
              <p class="subject-data">{{ fleetData?.paymentDetails?.branchName ? fleetData?.paymentDetails?.branchName : '-' }}</p>
            </div>
          </div>
          <div class="sub-section">
            <div class="item-row">
              <p class="subject-name">Account Type</p>
              <p class="subject-data">{{ fleetData?.paymentDetails?.accountType ? (fleetData?.paymentDetails?.accountType | titlecase) : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Account Holder Name</p>
              <p class="subject-data">{{ fleetData?.paymentDetails?.accountHolder ? fleetData?.paymentDetails?.accountHolder : '-'}}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Account Number</p>
              <p class="subject-data">{{ fleetData?.paymentDetails?.accountNumber ? fleetData?.paymentDetails?.accountNumber  :'-'}}</p>
            </div>
          </div>
          <div class="sub-section">
            <p class="subject-name">Attachments</p>
            <div class="flex flex-col mt-2">
              <a *ngFor="let file of fleetData?.paymentDetails?.bankInfoFiles" href="{{file.url}}"
                 [nz-tooltip]="file.name"
                 target="_blank"><span nz-icon nzType="file" class="text-sm"
                                       nzTheme="outline"></span><span
                class="ml-2 text-sm"> - {{ file.name }}</span></a>
            </div>
          </div>
        </div>
      </nz-card>
    </div>

    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template [typeName]="'single-fleet-view'"></app-single-view-skeleton-template>
    </div>
  </nz-tab>

  <nz-tab *appHasAnyPrivilege="'INVENTORY_RECORDS_VIEW'" nzTitle="Inventory Records"
          (nzClick)="updateBreadcrumbs('Inventories')">
    <app-view-inventory *ngIf="isOpen === 'inventories'" [fleetData]="fleetData"></app-view-inventory>
  </nz-tab>
  <nz-tab *appHasAnyPrivilege="'SERVICE_RECORDS_VIEW'" nzTitle="Service Records"
          (nzClick)="updateBreadcrumbs('Services')">
    <app-view-services *ngIf="isOpen === 'services'" [fleetData]="fleetData"></app-view-services>
  </nz-tab>
  <nz-tab *appHasAnyPrivilege="'REPAIR_RECORDS_VIEW'" nzTitle="Repair Records" (nzClick)="updateBreadcrumbs('Repairs')">
    <app-view-repairs *ngIf="isOpen === 'repairs'" [fleetData]="fleetData"></app-view-repairs>
  </nz-tab>
  <nz-tab *appHasAnyPrivilege="'ACCIDENT_RECORDS_VIEW'" nzTitle="Accident Records"
          (nzClick)="updateBreadcrumbs('Accidents')">
    <app-view-accidents *ngIf="isOpen === 'accidents'" [fleetData]="fleetData"></app-view-accidents>
  </nz-tab>
  <nz-tab *appHasAnyPrivilege="'NOTES_ATTACHMENTS_ATTACHMENT_VIEW,NOTES_ATTACHMENTS_NOTES_VIEW'"
          nzTitle="Notes and Attachments"
          (nzClick)="updateBreadcrumbs('Notes')">
    <app-notes-attachments *ngIf="isOpen === 'notes'" [fleetData]="fleetData"></app-notes-attachments>
  </nz-tab>
</nz-tabset>

<nz-modal
  [(nzVisible)]="isVisibleFleetNoteModal"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancelAddFleetNote()"
>
  <ng-template #modalTitle>Add a reason for {{ this.fleetData.active ? 'deactivate' : 'activate' }} this fleet
  </ng-template>

  <ng-template #modalContent>
    <textarea rows="5" nz-input class="mt-5 mb-5" [(ngModel)]="description"></textarea>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button class="outline-button" (click)="handleCancelAddFleetNote()">Cancel</button>
    <button nz-button nzType="primary" (click)="handleOkAddFleetNote()">Ok</button>
  </ng-template>
</nz-modal>


<nz-modal
  [(nzVisible)]="isShowReport"
  [nzTitle]="modalTitle12"
  [nzContent]="modalContent12"
  [nzFooter]="modalFooter12"
  (nzOnCancel)="handleCancel()"
  nzClosable="false"
>
  <ng-template #modalTitle12>
    <div class="flex justify-between items-center my-4">
      <h4 *ngIf="!selector">Initial Inventory Report</h4>
      <h4 *ngIf="selector"> Generate Car Rental Agreement</h4>
      <button *appHasAnyPrivilege="''" nz-button nzType="primary" [disabled]="!this.pdfLoader" (click)="viewPdf()">Preview</button>
    </div>
  </ng-template>

  <ng-template #modalContent12>
    <div class="my-4">
      <p style="font-weight: normal; color:#F06A21" *ngIf="!this.pdfLoader">Report Generating ....</p>
      <p style="font-weight: normal" *ngIf="this.pdfLoader">Report Generated Successfully!</p>
    </div>
  </ng-template>

  <ng-template #modalFooter12>
    <div class="flex justify-between items-center my-4">
      <button nz-button nzType="default" style="color: white; background: #9A9A9A" (click)="handleCancel()">
        Cancel
      </button>
      <div class="flex gap-2">
        <button *appHasAnyPrivilege="''" nz-button nzType="default" [disabled]="!this.pdfLoader" class="outline-button" (click)="downloadPdf()">
          Download
        </button>
        <button *appHasAnyPrivilege="''" nz-button nzType="default" [disabled]="!this.pdfLoader" class="outline-button" (click)="emailPdf()">
          Send
        </button>
                <button nz-button nzType="default" [disabled]="!this.pdfLoader" class="outline-button" (click)="printReport()">
                  Print
                </button>
      </div>
    </div>
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle14"
  [nzContent]="modalContent14"
  [nzFooter]="modalFooter14"
  (nzOnCancel)="handleCanceImgModall()"
  [nzWrapClassName]="'lightbox-modal'"
>
  <ng-template #modalTitle14></ng-template>

  <ng-template #modalContent14>
    <div class="">
      <img [src]="selectedImage" class="h-[70vh] max-h-[70vh] w-[90vw] xl:w-[50vw] xl:h-full object-contain" alt="image">
    </div>
  </ng-template>

  <ng-template #modalFooter14>

  </ng-template>
</nz-modal>
